import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const REQUISITION_VALIDATION = FORM_FIELDS.INVENTORY.REQUISITION;

export const requisitionValidationSchema = yup.object().shape({
  [REQUISITION_VALIDATION.REQUESTER_TYPE]: yup
    .string()
    .required("Please select requesting for type"),
  [REQUISITION_VALIDATION.REQ_DATE]: yup
    .string()
    .required("Please provide requisition date"),
  // [REQUISITION_VALIDATION.LETTER]: yup.string().required("Letter is required"),
  // [REQUISITION_VALIDATION.FILE]: yup.array().of(
  //   yup
  //     .object()
  //     .shape({
  //       name: yup.string(),
  //       mimeType: yup.string(),
  //       fileId: yup.string(),
  //       documentId: yup.string(),
  //       documentType: yup.string(),
  //     })
  //     .required("Please provide document"),
  // ),
});

export type RequisitionValidationSchemaType = yup.InferType<
  typeof requisitionValidationSchema
>;
